import { useI18n } from '../../i18n/I18nProvider';
import { cn } from '../../lib/cn';

// Marca de la app: el logo oficial de Metamorfosis Origen
// (public/branding/logo-metamorfosis.png, 1200x320, verde oliva sobre transparente,
// recortado del original de Ailen el 15/09/2026). Si cambia el logo, se reemplaza
// ese archivo y este componente; ningún otro lugar lo conoce.
//
// El alto se controla con clases (h-7, h-16...); el ancho sigue solo (3.75:1).

const LOGO = '/branding/logo-metamorfosis.png';
const RATIO = 'aspect-[15/4]';

type Variante = 'white' | 'primary';

// white: siempre blanco (va sobre el primario: cabecera, hero del login).
// primary: el verde del logo en claro; en oscuro lo aclara --logo-filter (tokens.css).
const FILTRO: Record<Variante, string> = {
  white: 'brightness-0 invert',
  primary: '[filter:var(--logo-filter)]',
};

interface MarcaLogoProps {
  variant?: Variante;
  className?: string;
}

/** Horizontal, para cabecera, hero y pie. */
export function MarcaLogo({ variant = 'primary', className }: MarcaLogoProps): JSX.Element {
  const es = useI18n();
  return (
    <img
      src={LOGO}
      alt={es.app.organizacion}
      draggable={false}
      className={cn('block w-auto select-none', RATIO, FILTRO[variant], className)}
    />
  );
}

/** Grande y centrado, para login y home. Sigue el tema (verde en claro, claro en oscuro). */
export function MarcaEmblema({ className }: { className?: string }): JSX.Element {
  return <MarcaLogo variant="primary" className={cn('mx-auto h-16', className)} />;
}
